import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.parse-int";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.is-array";
import _sumBy from "lodash/sumBy";
import _slice from "lodash/slice";
import _size from "lodash/size";
import _isEqual from "lodash/isEqual";
import _isNil from "lodash/isNil";
import _findIndex from "lodash/findIndex";
import _find from "lodash/find";
import _unionBy from "lodash/unionBy";
import _pull from "lodash/pull";
import _uniq from "lodash/uniq";
import _cloneDeep from "lodash/cloneDeep";
import _indexOf from "lodash/indexOf";
import _floor from "lodash/floor";
import _sortBy from "lodash/sortBy";
import _map from "lodash/map";
import _values from "lodash/values";
import _reduce from "lodash/reduce";
import _filter from "lodash/filter";
import _every from "lodash/every";
import _some from "lodash/some";
import _get from "lodash/get";
import _includes from "lodash/includes";
import _omit from "lodash/omit";
import _keys from "lodash/keys";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Num } from '@nerdwallet/nw-client-lib';
import url from 'url';
import moment from 'moment';
import numeral from 'numeral';
import BigNumber from 'bignumber.js';
import nwApiSDK from '@nerdwallet/nw-api-sdk';
import { DATE_FORMAT, ProviderAccountState, ProviderErrorResolutionActions, YodleeAccountSubTypePropertyName, TransactionCategories, TransactionFilters, TransactionCategoriesV2, NWFinancialAccountTypes, EverythingElseCategoryKey } from "../constants";
import { toTitleCase } from "./string-utils";
/**
 * Converts a byte array to base64.
 *
 * HERE BE DRAGONS (3/26/2018):
 * We expect that Yodlee sends images as byte arrays. Sometimes (we have seen in Staging),
 * Yodlee sends base64 instead, so we have to check if byteArray is actually an array.
 *
 * @param {array} byteArray
 * @returns {string|*}
 */

export var arrayBufferToBase64 = function arrayBufferToBase64(byteArray) {
  if (Array.isArray(byteArray)) {
    return Buffer.from(byteArray).toString('base64');
  }

  return byteArray;
};
export var formatAmount = function formatAmount(amount) {
  var includeCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return Num.formatCurrency(amount, includeCents);
};
export var getTransactionData = function getTransactionData(transactions, filter) {
  if (!filter || _keys(filter).length === 0) {
    return transactions.buckets.all;
  }

  var key = _keys(filter)[0];

  var value = filter[key];

  if (!transactions.buckets[key]) {
    return undefined;
  }

  return transactions.buckets[key][value];
};
export var isUserIDField = function isUserIDField(_ref) {
  var name = _ref.name;
  return name === 'LOGIN';
};
export var isPasswordField = function isPasswordField(_ref2) {
  var type = _ref2.type;
  return type === 'password';
};
export var isCaptchaField = function isCaptchaField(_ref3) {
  var image = _ref3.image;
  return image !== undefined;
};
export var getTransactionName = function getTransactionName(transaction) {
  return transaction.canonical_merchant_name || transaction.description;
};
export var getTransactionAmount = function getTransactionAmount(transaction) {
  var includeCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return formatAmount(transaction.amount, includeCents);
};
export var getTransactionDate = function getTransactionDate(transaction) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMM DD, YYYY';
  return moment(transaction.date).format(format);
};
export var isTransactionPosted = function isTransactionPosted(transaction) {
  return transaction.status === 'POSTED';
};
export var isTransactionPending = function isTransactionPending(transaction) {
  return transaction.status === 'PENDING';
};
export var shouldStoreTransaction = function shouldStoreTransaction(transaction) {
  return isTransactionPosted(transaction) || isTransactionPending(transaction);
};
/**
 * For a given transaction, merges category v1 and category v2 fields.
 *
 * If `category` is not null, then Transaction Category v1 is being used.
 * If `category_v2` is not null, then Transaction Category v2 is being used.
 *
 * @param {Object} transaction Transaction canonical object
 *
 * @return {Object} Returns modified transaction object
 */

export var mergeTransactionCategory = function mergeTransactionCategory(transaction) {
  var categoryVersion = transaction.category_v2 ? 2 : 1;
  var mergedTransaction = categoryVersion === 2 ? _objectSpread(_objectSpread({}, transaction), {}, {
    category: transaction.category_v2,
    category_override: transaction.transaction_category_v2_override,
    merchant_category_override: transaction.merchant_category_v2_override
  }) : _objectSpread(_objectSpread({}, transaction), {}, {
    category: transaction.category,
    category_override: transaction.category_override,
    merchant_category_override: transaction.merchant_category_override
  });
  return _omit(mergedTransaction, ['category_v2', 'transaction_category_v2_override', 'merchant_category_v2_override']);
};
export var isSpendingTransactionCategory = function isSpendingTransactionCategory(category) {
  return !_includes([TransactionCategories.OMIT, TransactionCategories.INCOME, TransactionCategoriesV2.TRANSFERS, TransactionCategoriesV2.INCOME], category);
};
export var isIncomeCategory = function isIncomeCategory(category) {
  return category === TransactionCategories.INCOME || category === TransactionCategoriesV2.INCOME;
};
export var isIncomeTransaction = function isIncomeTransaction(transaction) {
  return transaction.base_type === 'CREDIT';
};
export var getSumFieldForAccountType = function getSumFieldForAccountType(type) {
  switch (type) {
    case 'bank':
      return 'sum_bank_balances';

    case 'creditCard':
      return 'sum_credit_card_balances';

    case 'loan':
      return 'sum_loan_balances';

    case 'investment':
      return 'sum_investment_balances';

    default:
      return undefined;
  }
};
export var getTransactionSignedAmount = function getTransactionSignedAmount(transaction) {
  var includeCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (isIncomeTransaction(transaction)) {
    return formatAmount(transaction.amount, includeCents);
  }

  return formatAmount(transaction.amount * -1, includeCents);
};
export var isProviderAccountRefreshing = function isProviderAccountRefreshing(providerAccount) {
  return _get(providerAccount, 'provider_account_state.is_refreshing', false);
};
export var isProviderAccountSyncing = function isProviderAccountSyncing(providerAccount) {
  return !isProviderAccountRefreshing(providerAccount) && (_get(providerAccount, 'provider_account_state.state') === ProviderAccountState.AUTHENTICATED || _get(providerAccount, 'provider_account_state.state') === ProviderAccountState.LOGIN_IN_PROGRESS || _get(providerAccount, 'provider_account_state.state') === ProviderAccountState.MFA_IN_PROGRESS || _get(providerAccount, 'provider_account_state.is_active_sync') === true);
};
export var doesProviderAccountNeedAutoRefresh = function doesProviderAccountNeedAutoRefresh(providerAccount) {
  return !isProviderAccountRefreshing(providerAccount) && !isProviderAccountSyncing(providerAccount) && _get(providerAccount, 'provider_account_state.auto_refresh_required', false) && _get(providerAccount, 'provider_account_state.is_refreshable', false);
};
export var doesProviderAccountNeedMfa = function doesProviderAccountNeedMfa(providerAccount) {
  return _get(providerAccount, 'provider_account_state.state') === ProviderAccountState.MFA_REQUIRED;
};
export var areProviderAccountTransactionsSyncing = function areProviderAccountTransactionsSyncing(providerAccount) {
  return _some(_get(providerAccount, 'accounts'), function (account) {
    return account.transactions_last_synced_at === null;
  });
};
export var getShouldRefreshToFixProviderError = function getShouldRefreshToFixProviderError(providerAccount) {
  return _get(providerAccount, 'provider_account_state.error_resolutions.primary_action') === ProviderErrorResolutionActions.REFRESH && _get(providerAccount, 'provider_account_state.state') === ProviderAccountState.ERROR;
};
export var getProviderAccountErrorPriority = function getProviderAccountErrorPriority(providerAccount) {
  return _get(providerAccount, 'provider_account_state.error_priority');
};
export var getYodleeAccountName = function getYodleeAccountName(account) {
  var accountName;

  if (account.account_name && account.account_number_last_4) {
    accountName = "".concat(toTitleCase(account.account_name), " (").concat(account.account_number_last_4, ")");
  } else if (account.account_name) {
    accountName = toTitleCase(account.account_name);
  } else if (account.account_number_last_4) {
    accountName = "Account ending in ".concat(account.account_number_last_4);
  }

  return accountName;
};
export var getYodleeAccountIsRefreshing = function getYodleeAccountIsRefreshing(account) {
  return [ProviderAccountState.LOGIN_IN_PROGRESS].indexOf(account && account.account_status) > 0;
};
export var getYodleeAccountSubType = function getYodleeAccountSubType(account) {
  var propertyName = _get(YodleeAccountSubTypePropertyName, account.yodlee_account_type, null);

  return _get(account, propertyName, null);
};
export var getRefreshTimestampForAccount = function getRefreshTimestampForAccount(account) {
  return _get(account, 'last_refreshed');
};
/**
 * Returns a MMMM DD, YYYY formatted date for the last refresh date of an account
 *
 * @param {object} account - account to get timestamp of
 * @returns {string} - last refresh date formatted as MMMM DD, YYY
 */

export var getSyncTimestampForAccount = function getSyncTimestampForAccount(account) {
  var lastSyncedAt = _get(account, 'last_refreshed');

  if (lastSyncedAt) {
    return moment(new Date(lastSyncedAt)).format('MMMM DD, YYYY');
  }

  return null;
};
export var getSyncTimestampForProviderAccount = function getSyncTimestampForProviderAccount(providerAccount) {
  return getSyncTimestampForAccount(_get(providerAccount, 'accounts[0]'));
};
export var isChoiceField = function isChoiceField(row) {
  if (row.fieldRowChoice) {
    return row.fieldRowChoice.indexOf('Choice') > -1;
  }

  return false;
};
export var formatOption = function formatOption(_ref4) {
  var optionValue = _ref4.optionValue,
      displayText = _ref4.displayText;
  return {
    value: optionValue,
    label: displayText
  };
};
export var formatField = function formatField(_ref5) {
  var id = _ref5.id,
      name = _ref5.name,
      type = _ref5.type,
      value = _ref5.value,
      option = _ref5.option,
      maxLength = _ref5.maxLength,
      image = _ref5.image,
      rest = _objectWithoutProperties(_ref5, ["id", "name", "type", "value", "option", "maxLength", "image"]);

  var formatted = {
    id: id,
    name: name,
    type: type,
    value: value,
    required: !rest.isOptional,
    disabled: !rest.valueEditable,
    maxLength: maxLength
  };

  if (image) {
    formatted.type = 'image';
    var imageData = arrayBufferToBase64(image);
    formatted.imageData = "data:image/bmp;base64,".concat(imageData);
  }

  if (option) {
    formatted.options = option.map(formatOption);
  }

  return formatted;
};
export var formatRow = function formatRow(_ref6) {
  var id = _ref6.id,
      label = _ref6.label,
      field = _ref6.field,
      providerName = _ref6.providerName;
  var fields = field.slice(0);
  var firstField = fields[0];
  var subLabel;
  var labelText = label;

  if (firstField && isPasswordField(firstField)) {
    labelText = "".concat(providerName, " ").concat(label);
  }

  if (firstField && isCaptchaField(firstField)) {
    labelText = 'Security code';
  }

  return {
    id: id,
    label: labelText,
    subLabel: subLabel,
    type: 'field-group',
    fields: fields.map(formatField)
  };
};
export var addChoicesToFields = function addChoicesToFields(choices, fields) {
  var choiceNames = Object.keys(choices);
  choiceNames.forEach(function (choiceName) {
    var choice = {
      type: 'choice',
      label: 'Choose one',
      options: [],
      choices: []
    };
    choices[choiceName].forEach(function (choiceField, i) {
      choice.id = choiceField.id;
      choice.options.push({
        value: i,
        label: choiceField.label
      });

      if (i === 0) {
        choice.value = i;
      }

      choice.choices.push(formatRow(choiceField));
    });
    var idx = choiceName.replace(' Choice', '');
    idx = idx.replace(/0*/, '');
    idx -= 1; // -1 as our list starts at 0 and yodlee starts at 1

    fields.splice(idx, 0, choice);
  });
};
export var mapLoginForm = function mapLoginForm(loginForm) {
  var allFields = [];
  var choiceFields = {};

  var rows = _get(loginForm, 'row', []);

  rows.forEach(function (row) {
    if (isChoiceField(row)) {
      var choice = choiceFields[row.fieldRowChoice];

      if (choice === undefined) {
        choice = [];
        choiceFields[row.fieldRowChoice] = choice;
      }

      choice.push(row);
    } else {
      allFields.push(formatRow(_objectSpread(_objectSpread({}, row), {}, {
        providerName: loginForm.providerName
      })));
    }
  });

  if (Object.keys(choiceFields).length > 0) {
    addChoicesToFields(choiceFields, allFields);
  }

  return allFields;
};

var isFormRowComplete = function isFormRowComplete(formRow, formState) {
  return _every(_filter(formRow.field, {
    isOptional: false
  }), function (field) {
    return Boolean(_get(formState, field.id));
  });
}; // Returns true iff every non-optional field in the form has a corresponding value in formState


export var isFormComplete = function isFormComplete(form, formState) {
  return _every(form.row, function (row) {
    return isFormRowComplete(row, formState);
  });
}; // Turns a url like http://www.foo.com/bar/?hi=bye into www.foo.com/bar

export var formatLoginUrl = function formatLoginUrl() {
  var loginUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // identity sets login_url to null if it doesn't exist, and ES6 default parameter defaults
  // only get applied when arguments are undefined, so we need to "reapply" the default here.
  var uglyUrl = loginUrl === null ? '' : loginUrl;
  var parsedUrl = url.parse(uglyUrl);
  var prettyUrl;

  if (parsedUrl.host && parsedUrl.pathname) {
    prettyUrl = parsedUrl.host + parsedUrl.pathname;
  } else {
    return undefined;
  }

  var finalUrl; // If there is a trailing slash, remove it

  if (prettyUrl[prettyUrl.length - 1] === '/') {
    finalUrl = prettyUrl.substring(0, prettyUrl.length - 1);
  } else {
    finalUrl = prettyUrl;
  }

  return finalUrl;
};
/**
 * Returns whether the provided filter is valid.
 *
 * @param {Object} filter
 * @returns {boolean}
 */

export var isValidTransactionsFilter = function isValidTransactionsFilter(filter, transactionCategoryVersion) {
  // We only support one or no keys for now.
  var hasTooManyKeys = _keys(filter).length > 1;

  var hasValidKeys = _reduce(_keys(filter), function (isValid, key) {
    return isValid && _includes(TransactionFilters, key);
  }, true);

  var isCategoryValid = transactionCategoryVersion === 2 ? _includes(_values(TransactionCategoriesV2), filter.category) : _includes(_values(TransactionCategories), filter.category);

  if (hasTooManyKeys || !hasValidKeys || filter.category && !isCategoryValid) {
    return false;
  }

  return true;
};
export var compareCategoriesDescending = function compareCategoriesDescending(a, b) {
  return b.value - a.value;
};
/**
 * Parses spending data into a format that can be used in the Spending Graph.
 *
 * @param {Object} monthSpending - Object in the shape { [date]: float, ... }
 *
 * @returns {Object[]}
 */

export var getMonthSpendingDataByDate = function getMonthSpendingDataByDate(monthSpending) {
  var data = _map(monthSpending, function (value, date) {
    return {
      date: date,
      ordinal: moment(date, DATE_FORMAT.STANDARD).format('Do'),
      value: new BigNumber(value)
    };
  });

  data = _sortBy(data, 'date');
  data = _reduce(data, function (acc, _ref7, index) {
    var date = _ref7.date,
        value = _ref7.value,
        ordinal = _ref7.ordinal;
    acc.push({
      date: date,
      ordinal: ordinal,
      value: value,
      cumulativeValue: _get(acc[index - 1], 'cumulativeValue', new BigNumber(0)).plus(value)
    });
    return acc;
  }, []);
  return _map(data, function (_ref8) {
    var date = _ref8.date,
        value = _ref8.value,
        ordinal = _ref8.ordinal,
        cumulativeValue = _ref8.cumulativeValue;
    return {
      date: date,
      ordinal: ordinal,
      // Convert BigNumber to primitive
      value: value.toNumber(),
      cumulativeValue: cumulativeValue.toNumber()
    };
  });
};
/**
 * Parses spending data into a format that can be used in the Spending Graph.
 *
 * @deprecated Renamed for clarity. Use `getMonthSpendingDataByDate` instead.
 *
 * @param {Object} monthSpending - Object in the shape { [date]: float, ... }
 *
 * @returns {Object[]}
 */

export var parseSpendingData = function parseSpendingData(monthSpending) {
  return getMonthSpendingDataByDate(monthSpending);
};
/**
 * Parses spending data into a format that can be used in the Spending Graph.
 *
 * @param {Object} monthSpending - Object in the shape { [dayInMonth]: float, ... }
 *
 * @returns {Object[]}
 */

export var getMonthSpendingDataByDay = function getMonthSpendingDataByDay(monthSpending) {
  var data;
  data = _map(monthSpending, function (value, dayInMonth) {
    return {
      dayInMonth: Number.parseInt(dayInMonth, 10),
      value: new BigNumber(value)
    };
  });
  data = _sortBy(data, 'dayInMonth');
  data = _reduce(data, function (acc, _ref9, index) {
    var dayInMonth = _ref9.dayInMonth,
        value = _ref9.value;
    acc.push({
      dayInMonth: dayInMonth,
      value: value,
      cumulativeValue: _get(acc[index - 1], 'cumulativeValue', new BigNumber(0)).plus(value)
    });
    return acc;
  }, []);
  return _map(data, function (_ref10) {
    var dayInMonth = _ref10.dayInMonth,
        value = _ref10.value,
        cumulativeValue = _ref10.cumulativeValue;
    return {
      dayInMonth: dayInMonth,
      // Convert BigNumber to primitive
      value: value.toNumber(),
      cumulativeValue: cumulativeValue.toNumber()
    };
  });
};
/**
 * Returns the highest Y-axis value on the Monthly Spending Graph.
 *
 * @param {number} value
 * @returns {number}
 */

export var getRoundedTickValue = function getRoundedTickValue(value) {
  if (value === 0) {
    return 4000;
  }

  if (value < 10) {
    return value;
  }

  var precision = -1;
  var base = 1000;

  while (value > base) {
    precision -= 1;
    base *= 10;
  }

  return _floor(value, precision);
};
/**
 * Formats the Y-axis tick value into a nice format.
 *
 * @param value
 * @returns {string}
 */

export var formatTick = function formatTick(value) {
  if (value < 1000) {
    return Math.round(value).toString();
  }

  return numeral(value).format('0.0a').replace('.0', '').toUpperCase();
};
/**
 * Returns whether a date is the end of its month.
 *
 * @param date
 * @returns {boolean}
 */

export var isEndOfMonth = function isEndOfMonth(date) {
  var momentDate = moment(date, DATE_FORMAT.STANDARD);
  return momentDate.isSame(moment(momentDate).endOf('month').format(DATE_FORMAT.STANDARD));
};
export var isTransactionIgnored = function isTransactionIgnored(transaction) {
  return _indexOf(transaction.tags, nwApiSDK.IDENTITY_TRANSACTION_TAGS.IGNORED) >= 0;
};
/**
 * Returns a list of predicted bill transactions for the current month.
 *
 * Predicted bills are:
 *  - A clone of the list of last month's bills,
 *  - Use a "next_bill_date" field which is the date plus 1 month
 *
 * @param {Array}  bills Bills transactions
 * @param {string} date  Date as YYYY-MM-DD
 *
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 *
 * @return {Array} Array of predicted bills
 */

export var createPredictedBills = function createPredictedBills(bills, date) {
  var lastMonth = moment(date, DATE_FORMAT.STANDARD).subtract(1, 'month');

  var lastMonthBills = _filter(bills, function (bill) {
    return !isTransactionIgnored(bill) && _indexOf(bill.tags, nwApiSDK.IDENTITY_TRANSACTION_TAGS.NOT_RECURRING) === -1 && moment(lastMonth).isSame(bill.date, 'month');
  });

  return _map(lastMonthBills, function (bill) {
    return _objectSpread(_objectSpread({}, bill), {}, {
      next_bill_date: moment(bill.date).add(1, 'month').format(DATE_FORMAT.STANDARD)
    });
  });
};
/**
 * Returns a list of predicted bill transactions occurring before a given date.
 *
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 *
 * @param {Array}  bills Bills transactions
 * @param {string} date  Date as YYYY-MM-DD
 *
 * @return {Array}
 */

export var getPastPredictedBills = function getPastPredictedBills(bills, date) {
  var predictedBills = createPredictedBills(bills, date);
  return _filter(predictedBills, function (bill) {
    return moment(bill.next_bill_date).isBefore(date);
  });
};
/**
 * Returns a list of predicted bill transactions occurring after a given date (inclusive).
 *
 * @deprecated This is for the Bills Hack feature, which is deprecated in favor of the Upcoming Bills feature.
 *
 * @param {Array}  bills Bills transactions
 * @param {string} date  Date as YYYY-MM-DD
 *
 * @return {Array}
 */

export var getFuturePredictedBills = function getFuturePredictedBills(bills, date) {
  var predictedBills = createPredictedBills(bills, date);
  return _filter(predictedBills, function (bill) {
    return moment(bill.next_bill_date).isSameOrAfter(date);
  });
};
/**
 * Sums the total amount of credit and debit transactions.
 *
 * @param {array} transactions
 * @return {*}
 */

export var sumTransactionAmounts = function sumTransactionAmounts(transactions) {
  return _reduce(transactions, function (acc, transaction) {
    return isIncomeTransaction(transaction) ? acc - transaction.amount : acc + transaction.amount;
  }, 0);
};
/**
 * Adds a tag to a transaction and returns a new transaction.
 *
 * @param {object} transaction
 * @param {string} tag
 *
 * @return {object} Transaction with updated tags
 */

export var addTagToTransaction = function addTagToTransaction(transaction, tag) {
  var tags = _cloneDeep(transaction.tags) || [];
  tags.push(tag);
  return _objectSpread(_objectSpread({}, transaction), {}, {
    tags: _uniq(tags)
  });
};
/**
 * Removes a tag to a transaction and returns a new transaction.
 *
 * @param {object} transaction
 * @param {string} tag
 *
 * @return {object} Transaction with updated tags
 */

export var removeTagFromTransaction = function removeTagFromTransaction(transaction, tag) {
  var tags = _cloneDeep(transaction.tags);

  if (tags) {
    _pull(tags, tag);
  }

  return _objectSpread(_objectSpread({}, transaction), {}, {
    tags: tags
  });
};
/**
 * Retrieves all transactions from the buckets, note that this is not representative of
 * all the transactions a user might have since transactions can exist that are not
 * in any bucket. For this reason, to access all transactions it is recommended to use
 * the `getAllTransactions` Yodlee selector.
 *
 * @deprecated Use {@link getAllTransactions}
 * */

export var getAllTransactionsFromBuckets = function getAllTransactionsFromBuckets(buckets) {
  return _reduce(buckets, function (transactions, bucket, bucketKey) {
    if (bucketKey === 'all') {
      return _unionBy(transactions, _get(bucket, 'transactions'), 'id');
    }

    var filterTransactions = _reduce(bucket, function (t, v) {
      return _unionBy(t, _get(v, 'transactions'), 'id');
    }, []);

    return _unionBy(transactions, filterTransactions, 'id');
  }, []);
};
/**
 * TODO: Fix mismatched logic with backend
 *
 * @param {Object} transaction
 * @param {string} transactionId
 * @param {string} canonicalMerchantName
 *
 * @return {boolean}
 */

export var shouldUpdateTransactionCategoryForMerchantName = function shouldUpdateTransactionCategoryForMerchantName(transaction, transactionId, canonicalMerchantName) {
  return transaction.id === transactionId || !transaction.category_override && transaction.canonical_merchant_name === canonicalMerchantName;
};
export var getIsAccountEnabled = function getIsAccountEnabled(account) {
  return _get(account, 'nw_enabled');
};
/**
 * Parses a `categoryWindowRollups` or `topMerchant` window string for the start and end dates.
 *
 * @param {string} windowKey - For example, "2019-09-01-2019-09-30"
 *
 * @return {{endDate: {String}, startDate: {String}}}
 */

export var getRollupWindowDates = function getRollupWindowDates(windowKey) {
  var regExp = /^(\d\d\d\d-\d\d-\d\d)-(\d\d\d\d-\d\d-\d\d)$/;
  var results = regExp.exec(windowKey);
  return {
    startDate: _get(results, [1], null),
    endDate: _get(results, [2], null)
  };
};
/**
 * Creates a rollup window key for a given start date and end date.
 *
 * @param {string} startDate - Date as YYYY-MM-DD
 * @param {string} endDate - Date as YYYY-MM-DD
 *
 * @return {string} Returns rollup window key representing start and end date.
 */

export var createWindowKey = function createWindowKey(startDate, endDate) {
  return "".concat(startDate, "-").concat(endDate);
};
/**
 * Creates a rollup window key for a given day in target month.
 *
 * @param {string|Moment} dayInTargetMonth
 *
 * @return {string} Concatenation of start and end dates, separated by "-"
 */

export var createMonthWindowKey = function createMonthWindowKey(dayInTargetMonth) {
  var startOfTargetMonth = moment(dayInTargetMonth).startOf('month').format(DATE_FORMAT.STANDARD);
  var endOfTargetMonth = moment(dayInTargetMonth).endOf('month').format(DATE_FORMAT.STANDARD);
  return createWindowKey(startOfTargetMonth, endOfTargetMonth);
};
export var getAllAccountsForProviderAccount = function getAllAccountsForProviderAccount(providerAccount) {
  return _get(providerAccount, 'accounts', []);
};
export var getIsProviderAccountInState = function getIsProviderAccountInState(providerAccount, providerAccountState) {
  return _get(providerAccount, 'provider_account_state.state') === providerAccountState;
};
export var getIsProviderAccountInActiveState = function getIsProviderAccountInActiveState(providerAccount) {
  return getIsProviderAccountInState(providerAccount, ProviderAccountState.ACTIVE);
};
export var getIsProviderAccountInErrorState = function getIsProviderAccountInErrorState(providerAccount) {
  return getIsProviderAccountInState(providerAccount, ProviderAccountState.ERROR);
};
export var getIsProviderAccountInMFARequiredState = function getIsProviderAccountInMFARequiredState(providerAccount) {
  return getIsProviderAccountInState(providerAccount, ProviderAccountState.MFA_REQUIRED);
};
export var getIsProviderAccountInActiveSync = function getIsProviderAccountInActiveSync(providerAccount) {
  return !!_get(providerAccount, 'provider_account_state.is_active_sync');
}; // It's possible that provider accounts can be ACTIVE, but have no underlying accounts.
// For now we're treating these accounts as having an ERROR.

export var getIsProviderAccountError = function getIsProviderAccountError(providerAccount) {
  return getIsProviderAccountInErrorState(providerAccount) || getIsProviderAccountInActiveState(providerAccount) && _get(providerAccount, 'accounts.length') === 0 && _get(providerAccount, 'provider_account_state.is_active_sync') === false;
};
export var getIsUserActionRequired = function getIsUserActionRequired(providerAccount) {
  return getIsProviderAccountError(providerAccount) || getIsProviderAccountInMFARequiredState(providerAccount);
};
export var getIsProviderAccountSyncingOrRefreshing = function getIsProviderAccountSyncingOrRefreshing(providerAccount) {
  return isProviderAccountSyncing(providerAccount) || isProviderAccountRefreshing(providerAccount);
};
export var getIsProviderAccountIAVEnabled = function getIsProviderAccountIAVEnabled(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.iav_enabled', false);
};
export var getIsProviderAccountIAVVerified = function getIsProviderAccountIAVVerified(providerAccount) {
  return _get(providerAccount, 'provider_account_state.iav_verified', false);
};
export var getIsProviderAccountAdminDeactivated = function getIsProviderAccountAdminDeactivated(providerAccount) {
  return _get(providerAccount, 'provider_account_state.provider.iav_admin_deactivated', false);
};
export var sortAccountsByDescendingBalance = function sortAccountsByDescendingBalance(accounts) {
  return _sortBy(accounts, function (_ref11) {
    var balance = _ref11.balance;
    return -balance;
  });
};
export var findProviderAccountByAccount = function findProviderAccountByAccount() {
  var providerAccounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var account = arguments.length > 1 ? arguments[1] : undefined;
  return _find(providerAccounts, function (providerAccount) {
    var _ref12;

    var accounts = (_ref12 = providerAccount === null || providerAccount === void 0 ? void 0 : providerAccount.accounts) !== null && _ref12 !== void 0 ? _ref12 : [];
    return _findIndex(accounts, function (a) {
      return (account === null || account === void 0 ? void 0 : account.id) === a.id;
    }) > -1;
  });
};
export var getIsYodleeAccountNWAccountofType = function getIsYodleeAccountNWAccountofType(account, type) {
  return _get(account, 'nw_type') === type;
};
export var getIsNWCheckingAccount = function getIsNWCheckingAccount(account) {
  return getIsYodleeAccountNWAccountofType(account, NWFinancialAccountTypes.CHECKING);
};
export var getIsNWSavingsAccount = function getIsNWSavingsAccount(account) {
  return getIsYodleeAccountNWAccountofType(account, NWFinancialAccountTypes.SAVINGS);
};
export var getIsNWInvestmentAccount = function getIsNWInvestmentAccount(account) {
  return getIsYodleeAccountNWAccountofType(account, NWFinancialAccountTypes.INVESTMENT);
};
export var getIsNWRetirementAccount = function getIsNWRetirementAccount(account) {
  return getIsYodleeAccountNWAccountofType(account, NWFinancialAccountTypes.RETIREMENT);
};
export var getHasAccountSyncedBalances = function getHasAccountSyncedBalances(account) {
  return _get(account, 'balance') >= 0;
};
export var getHasAccountSyncedTransactions = function getHasAccountSyncedTransactions(account) {
  return !!_get(account, 'transactions_last_synced_at');
}; // Accounts with Balances AND Transactions synced are ready to use

export var getHasAccountSyncedBalancesAndTransactions = function getHasAccountSyncedBalancesAndTransactions(account) {
  return getHasAccountSyncedBalances(account) && getHasAccountSyncedTransactions(account);
};
export var getHaveProviderAccountsChangedOrRefreshed = function getHaveProviderAccountsChangedOrRefreshed(prevProviders, nextProviders, prevProviderIds, nextProviderIds, isRefreshFailure, prevRefreshingProviders, nextRefreshingProviders) {
  // true if the list of active providers ever changes but NOT
  // on login/logout (in this case prevProviders or nextProviders is null)
  var haveLinkedProvidersChanged = !_isNil(prevProviders) && !_isNil(nextProviders) && !_isEqual(prevProviderIds.sort(), nextProviderIds.sort());

  var hasNewlyRefreshedProviders = !isRefreshFailure && prevRefreshingProviders && nextRefreshingProviders && _size(nextRefreshingProviders) < _size(prevRefreshingProviders);

  return haveLinkedProvidersChanged || hasNewlyRefreshedProviders;
};
export var getIAVEnabledSearchResults = function getIAVEnabledSearchResults(searchResults) {
  return searchResults && _filter(searchResults, function (searchResult) {
    return searchResult.iav_enabled && !searchResult.iav_admin_deactivated;
  });
};
export var getPrimarySourceFromProviderAccount = function getPrimarySourceFromProviderAccount(providerAccount) {
  return _get(providerAccount, 'provider_account_state.primary_source');
};
export var sortSpendingCategoryData = function sortSpendingCategoryData(unsortedData) {
  var sortedData = unsortedData.sort(compareCategoriesDescending);
  var maxNumCategories = 4;

  var numCategoriesWithSpending = _reduce(sortedData, function (acc, _ref13) {
    var value = _ref13.value;
    return value > 0 ? acc + 1 : acc;
  }, 0);

  var highestSpendingCategoriesData = _slice(sortedData, 0, maxNumCategories - 1);

  var lowestSpendingCategoriesData = _slice(sortedData, maxNumCategories - 1);

  var sumLowestSpendingCategorySpending = _sumBy(lowestSpendingCategoriesData, 'value');

  return numCategoriesWithSpending < maxNumCategories ? _slice(highestSpendingCategoriesData, 0, numCategoriesWithSpending) : [].concat(_toConsumableArray(highestSpendingCategoriesData), [{
    category: EverythingElseCategoryKey,
    value: sumLowestSpendingCategorySpending
  }]);
};